import src from "IMAGE";
export default { src, width: 739, height: 264, blurWidth: 0, blurHeight: 0};
